import React from 'react';
import { Link } from 'react-router-dom';

import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <div style={styles.container}>
      <SEO
        title="Pagina niet gevonden | Doorloopjes"
        description="Deze pagina bestaat niet of is verplaatst."
        noindex
      />
      <div style={styles.card}>
        <h1 style={styles.code}>404</h1>
        <h2 style={styles.title}>Pagina niet gevonden</h2>
        <p style={styles.text}>
          De pagina die je zoekt bestaat niet of is verplaatst.
        </p>
        <Link to="/" style={styles.button}>
          Terug naar home
        </Link>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--color-background-page, #eef1f5)',
    padding: '2rem',
  },
  card: {
    textAlign: 'center',
    maxWidth: 480,
  },
  code: {
    fontSize: '6rem',
    fontWeight: 700,
    color: 'var(--color-yellow, #ffdd00)',
    margin: 0,
    lineHeight: 1,
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: 'var(--color-text-primary, #231f20)',
    margin: '0.5rem 0',
  },
  text: {
    fontSize: '1rem',
    color: 'var(--color-dark-grey, #58595b)',
    marginBottom: '1.5rem',
  },
  button: {
    display: 'inline-block',
    padding: '0.75rem 1.5rem',
    backgroundColor: 'var(--color-yellow, #ffdd00)',
    color: 'var(--color-text-primary, #231f20)',
    fontWeight: 700,
    borderRadius: 8,
    textDecoration: 'none',
  },
};
